'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SkinConcerns = exports.CLASS_INITIALIZED = exports.CAROUSEL_SELECTOR = exports.CONTAINER_SELECTOR = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _CarouselSection2 = require('./../../sections/carousel/CarouselSection');

var _ShopifySection = require('./../../sections/ShopifySection');

var _Responsive = require('./../../settings/Responsive');

var ResponsiveSizes = _interopRequireWildcard(_Responsive);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CONTAINER_SELECTOR = exports.CONTAINER_SELECTOR = '[data-skin-concerns]'; /*
                                                                               *  Skin Concerns
                                                                               *    Carousel of concerns on all screens
                                                                               *
                                                                               *  Version:
                                                                               *    2.0.0 - 2022/01/27
                                                                               */

var CAROUSEL_SELECTOR = exports.CAROUSEL_SELECTOR = '[data-carousel]';

var CLASS_INITIALIZED = exports.CLASS_INITIALIZED = 'slick-initialized';

var SkinConcerns = exports.SkinConcerns = function (_CarouselSection) {
  (0, _inherits3.default)(SkinConcerns, _CarouselSection);

  function SkinConcerns(container) {
    (0, _classCallCheck3.default)(this, SkinConcerns);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SkinConcerns.__proto__ || Object.getPrototypeOf(SkinConcerns)).call(this, container));

    _this.carouselContainer = container.find(CAROUSEL_SELECTOR);
    _this.slick = _this.initCarousel(_this.carouselContainer);
    return _this;
  }

  (0, _createClass3.default)(SkinConcerns, [{
    key: 'optionOverrides',
    value: function optionOverrides() {
      return {
        infinite: true,
        autoplay: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        responsive: [{
          breakpoint: ResponsiveSizes.small - 1,
          settings: {
            slidesToShow: 4
          }
        }, {
          breakpoint: ResponsiveSizes.medium - 1,
          settings: {
            slidesToShow: 5,
            arrows: true
          }
        }, {
          breakpoint: ResponsiveSizes.xlarge - 1,
          settings: {
            slidesToShow: 8,
            arrows: true
          }
        }]
      };
    }
  }]);
  return SkinConcerns;
}(_CarouselSection2.CarouselSection);

(0, _ShopifySection.register)(CONTAINER_SELECTOR, SkinConcerns);